import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchResearchData,
  fetchPublicationData,
  downloadPublicationFile,
  fetchInternshipData,
} from "../../redux/slicer/researchAndStudentSlice";
import { TiArrowSortedDown } from "react-icons/ti";
import { FaLink, FaArrowUp } from "react-icons/fa";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { IoIosArrowForward } from "react-icons/io";
import StudentLifeCard from "./card_student_life";
import Events from "./events";
import Sports from "./sports";
import Background from "../../assets/Background3.png";
import Preloader from "../../assets/sab.jpeg";
import StudentlifeImG from "../../assets/Banners/StudentLife.jpg";
function StudentLife() {
  const dispatch = useDispatch();
  // Get research data from Redux store
  const [expandedAbstracts, setExpandedAbstracts] = useState({});
  const {
    data: researchData,
    loading: researchLoading,
    error: researchError,
  } = useSelector((state) => state.research.research);

  // Get publication data from Redux store
  const {
    data: publicationData,
    loading: publicationLoading,
    error: publicationError,
  } = useSelector((state) => state.research.publication);

  const {
    data: internshipData,
    loading: internshipLoading,
    error: internshipError,
  } = useSelector((state) => state.research.internship);

  const [activeTab, setActiveTab] = useState(
    Object.keys(researchData)[0] || "2023"
  );

  useEffect(() => {
    dispatch(fetchResearchData());
    dispatch(fetchPublicationData());
    dispatch(fetchInternshipData());
  }, [dispatch]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const toggleAbstract = (id) => {
    setExpandedAbstracts((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the expanded state for the clicked abstract
    }));
  };

  const MAX_WORDS = 50; // Limit for the number of words in the abstract

  const truncateText = (text, id) => {
    if (expandedAbstracts[id] || text.split(" ").length <= MAX_WORDS) {
      return text; // Show full text if expanded or text is within the limit
    }
    return text.split(" ").slice(0, MAX_WORDS).join(" ") + "...";
  };
  // if (researchLoading || publicationLoading || internshipLoading)
  //   return <p>Loading...</p>;
  // if (researchError || publicationError || internshipError)
  //   return <p>Error: {researchError || publicationError || internshipError}</p>;

  if (researchLoading || publicationLoading || internshipLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (researchError || publicationError || internshipError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error: {researchError || publicationError || internshipError}
        </p>
      </div>
    );
  }
  return (
    <div>
      <div className="relative max-w-full mx-auto">
        <div className="overflow-hidden w-full  h-[300px] sm:h-[400px]">
          <img
            // src={
            //   "https://files.unitasterdays.com/bespoke-pages/bpid654/img2023816670.jpg"
            // }
            src={StudentlifeImG} // included images
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-3xl sm:text-5xl font-bold  font-titillium">
              Student Life
            </h2>
            <p className="text-base sm:text-lg mt-4 sm:mt-10  font-titillium">
  
            </p>
          </div>
        </div>
      </div>
      <div className="py-6 mt-6">
        <p className="text-primary-color text-4xl  font-titillium">
          Student Life
        </p>
        <div className="px-4 sm:px-6 lg:px-28 py-6 mt-6">
          <h2
            className="text-left text-primary-color text-4xl  font-titillium"
            id="clubs"
          >
            Clubs & Societies
          </h2>
          <div className="bg-primary-color h-[1px] w-[150px] mt-5"></div>

          <div className="py-6">
            <StudentLifeCard />
          </div>

          <div className="mt-6 py-6" id="events">
            <p className="text-4xl text-primary-color text-left  font-titillium">
              Students Events
            </p>
            <div className="py-6">
              <Events />
            </div>
          </div>

          <div className="mt-6 py-6" id="sports">
            <p className="text-4xl text-primary-color  font-titillium">
              Sports
            </p>
            <div className="py-6">
              <Sports />
            </div>
          </div>

          {/* <div className="space-y-4 px-6 sm:px-16" id="patners">
            <p className="text-primary-color text-center"></p>
            <p className="text-2xl sm:text-4xl text-primary-color font-semibold text-center  font-titillium">
              Training Patners
            </p>
            <div className="px-4 sm:px-28 md:px-10 py-6">
              <TrainingPatners />
            </div>
          </div> */}

          {/* <div id="careers">
            <p className="text-4xl text-primary-color  font-titillium ">
              Career Guidence & InternShips
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {internshipData.map((internship) => (
                <div
                  key={internship.id}
                  className="w-full h-[200px] shadow-2xl rounded p-4 flex flex-col items-center justify-center text-center bg-[#92288C] bg-opacity-10"
                >
                  <h2 className="text-lg sm:text-2xl font-bold">
                    {internship.title}
                  </h2>

                  <div className="mt-4">
                    <button
                      className="bg-primary-color w-[150px] sm:w-[200px] h-[40px] text-white rounded"
                      onClick={() => window.open(internship.url, "_blank")} // Open URL in a new tab
                    >
                      Visit
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default StudentLife;
